import { render, staticRenderFns } from "./PatientProfile.vue?vue&type=template&id=31d68300&"
import script from "./PatientProfile.vue?vue&type=script&lang=js&"
export * from "./PatientProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d68300')) {
      api.createRecord('31d68300', component.options)
    } else {
      api.reload('31d68300', component.options)
    }
    module.hot.accept("./PatientProfile.vue?vue&type=template&id=31d68300&", function () {
      api.rerender('31d68300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/common/PatientProfile.vue"
export default component.exports